<template>
    <div class="content-item tx-userblog tx-userblog-list">
        <div class="list__wrapper">

            <div class="list-item -special" v-if="disableSpecial && categories.length > 0">
                <div class="list-buttons__wrapper -standalone">
                    <div class="button-headline" v-if="categoryHeadline">
                        <span class="heading gamma">{{ categoryHeadline }}</span>
                    </div>
                    <div class="button-item" v-for="(category) in categories"
                         :key="`blog__category--${category.uid}`"
                         :class="{ '-current': isCurrentCategory(category.uid)}">
                        <a v-if="category.link" :href="category.link">
                            <div v-if="category.icon" class="category-button__icon">
                                <img :src="category.icon.split('|')[0]" :title="category.icon.split('|')[1]"
                                     :alt="category.icon.split('|')[2]">
                            </div>
                            <div class="category-button__title">
                                <span>{{ category.title }}</span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <template v-for="(item, index) in entries" :key="`group-${item.uid}`">
                <billboard-content
                    :key="`billboard-${index}`"
                    v-if="(numberOfTotalArticles > billboardPosition && index === billboardPosition) || (numberOfTotalArticles <= billboardPosition && index === numberOfTotalArticles - 1)" />
                <div class="list-item"
                     :class="{ '-special': isSpecialItem(index) }"
                     :data-title="item.title">
                    <div class="item" v-if="item.link">
                        <a :href="item.link" class="list-element__image_wrapper" tabindex="-1" :title="item.title ? item.title : item.link">
                            <img :src="item.image.split('|')[0]"
                                 :title="item.image.split('|')[1]"
                                 :alt="item.image.split('|')[2]"
                                 v-if="item.image">
                            <div class="no-img" v-else></div>
                        </a>
                        <div class="list-element__content">
                            <div class="content__data">
                                <div class="content__category">
                                    <span v-if="index === 0 && !disableSpecial" class="content__date">{{ formatDate(item.date) }}</span>
                                    <a v-for="(cat) in item.category" :key="`category--${cat.uid}`" :href="cat.link"><span>{{ cat.title }}</span></a>
                                </div>
                                <a :href="item.link" v-if="item.title" class="content__title">
                                    <span class="heading epsilon">{{ item.title }}</span>
                                </a>
                                <div v-if="isSpecialItem(index)" class="content__description">
                                    <span v-html="item.description"></span>
                                </div>
                                <div v-if="index !== 0 || disableSpecial" class="content__date">
                <span>
                  {{ formatDate(item.date) }}
                </span>
                                </div>
                                <div class="content__button" v-if="isSpecialItem(index)">
                                    <a :href="item.link" class="btn -btn-alpha">
                                        <span>{{ $t('blogEntryList.readmore') }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="index===0 && !disableSpecial" class="list-buttons__wrapper">
                        <div class="button-headline" v-if="categoryHeadline">
                            <span class="heading delta">{{ categoryHeadline }}</span>
                        </div>
                        <div class="button-item" v-for="(category) in categories"
                             :key="`blog__category--${category.uid}`"
                             :class="{ '-current': isCurrentCategory(category.uid)}">
                            <a v-if="category.link" :href="category.link">
                                <div v-if="category.icon" class="category-button__icon">
                                    <img :src="category.icon.split('|')[0]" :title="category.icon.split('|')[1]"
                                         :alt="category.icon.split('|')[2]">
                                </div>
                                <div class="category-button__title">
                                    <span>{{ category.title }}</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </template>
            <div class="list-item list-item--placeholder"></div>
        </div>
        <div class="content-item module-load-more" v-if="numberOfTotalArticles > 0">
            <div class="load-more__button" v-if="currentPage < numberOfPages">
                <button type="button" class="btn -btn-alpha" @click="loadMoreEntries">
                    <span>{{ $t('blogEntryList.pagination.button') }}</span>
                </button>
            </div>
            <div class="load-more__progress" v-if="loaded">
                <div class="progress__info">
                    <span class="meta" v-html="$t('blogEntryList.pagination.loaded', { current: entries.length, total: numberOfTotalArticles })"></span>
                </div>
                <div class="progress__bar"><span :style="{ width: (entries.length / numberOfTotalArticles * 100) + '%' }"></span></div>
            </div>
        </div>
    </div>
</template>

<script>
import { h } from 'vue'
import { mapActions, mapState } from 'vuex'
const { mountBillboardContent } = require('./billboard.cjs')

const BillboardContent = {
  name: 'BillboardContent',
  mounted () {
    const template = document.getElementById('tx-user-blog-billboard-template')
    mountBillboardContent(template, this.$refs.container)
  },
  render () {
    return h('div', { class: 'list-billboard', ref: 'container' })
  }
}

export default {
  name: 'App',
  components: {
    BillboardContent
  },
  computed: {
    ...mapState({
      entries: 'entries',
      categories: 'categories',
      currentPage: 'currentPage',
      itemsPerPage: 'itemsPerPage',
      numberOfPages: 'numberOfPages',
      numberOfTotalArticles: 'numberOfTotalArticles',
      loaded: 'loaded',
      entriesFilter: 'entriesFilter',
      categoryHeadline: 'categoryHeadline',
      disableSpecial: 'disableSpecial',
      billboardPosition: 'billboardPosition'
    })
  },
  methods: {
    formatDate: function (date) {
      return new Date(date).toLocaleDateString(this.$store.state.locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    },
    isSpecialItem: function (index) {
      if (index === 0 && !this.disableSpecial) {
        return true
      }
      return false
    },
    isCurrentCategory: function (current) {
      if (current.toString() === this.entriesFilter.toString()) {
        return true
      }
      return false
    },
    loadMoreEntries: function () {
      this.increasePage()
      this.getEntries()
    },
    ...mapActions([
      'getEntries',
      'getCategories',
      'increasePage'
    ])
  },
  created () {
    this.getEntries()
  }
}
</script>
